import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { 
  MapPin, 
  Users, 
  Building2, 
  Home,
  Search,
  ChevronDown,
  ChevronUp,
  Church,
  Landmark,
  Image
} from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// Local Samaj Darshan data from Google Doc
const localSamajData = [
  {
    id: 'jodhpur',
    name: 'जोधपुर',
    nameEn: 'Jodhpur',
    state: 'राजस्थान',
    families: '625+',
    images: ['Jodhpur_1.jpeg', 'Jodhpur_2.jpeg'],
    description: `जोधपुर हमारे समाज के लिये केंद्र रहा है और यहां के समाज बंधुओं ने यह भूमिका भी बखूबी निभाई है। 1950 के दशक से आज तक के काल खंड का अध्ययन करने पर पाते हैं कि यहां के समाज बंधुओं ने शिक्षा, संगठन, सहयोग, रीति रिवाज, संस्कृति आदि क्षेत्रों में महत्वपूर्ण कार्य कर समस्त समाज को सकारात्मक संदेश दिया है।

समाज में शिक्षा के प्रसार के लिये छात्रावास की स्थापना, अखिल भारतीय स्तर पर समाज संगठन (महासभा की स्थापना व संचालन, युवक परिषद् की स्थापना, हिंगलाजज्योति का प्रकाशन, समाज के सम्मेलन आयोजित करना आदि), सामूहिक विवाह की शुरुआत, परिचय सम्मेलन, रीति-रिवाजों में समयानुकूल सुधार करना, रामदेवरा में धर्मशाला की स्थापना आदि में जोधपुर के समाज बंधुओं की अग्रणी व महत्वपूर्ण भूमिका रही है।

जोधपुर में कभी समाज के 10-15 परिवार हुआ करते थे, आज 625+ परिवार हैं। स्थानीय स्तर पर समाज भवन का निर्माण व उत्तरोत्तर विकास हुआ है। भवन में मां श्री हिंगलाज के विग्रह की स्थापना अत्यन्त शुभ व मंगलकारी है। मां के आशीर्वाद से समाज विकासोन्मुख है। समाज की गतिविधियों व समाज बंधुओं के कार्यों के लिये भवन वरदान सिद्ध हुआ है। बढती आवश्यकताओं को देखते हुये बड़े भवन की योजना विचाराधीन है।`,
    organizations: [
      'श्री जोधपुर ब्रह्मक्षत्रिय समाज संस्था',
      'श्री जोधपुर ब्रह्मक्षत्रिय महिला मंडल',
      'श्री जोधपुर ब्रह्मक्षत्रिय नवयुवक मंडल'
    ],
    highlight: 'जोधपुर हमारे समाज के लिये केंद्र रहा है और यहां के समाज बंधुओं ने यह भूमिका बखूबी निभाई है'
  },
  {
    id: 'barmer',
    name: 'बाड़मेर',
    nameEn: 'Barmer',
    state: 'राजस्थान',
    families: '870',
    images: ['Barmer_1.jpeg', 'Barmer_2.jpeg', 'Barmer_3.jpeg', 'Barmer_4.jpeg', 'Barmer_5.jpeg', 'Barmer_6.jpeg', 'Barmer_7.jpeg'],
    description: `बाड़मेर में हमारे समाज के सर्वाधिक परिवार निवास करते हैं। वर्तमान में परिवारों की संख्या 870 बतायी गयी है। बाड़मेर समाज व समाज बंधुओं का समाज के अखिल भारतीय समाज संगठनों व गतिविधियों में महत्वपूर्ण योगदान रहा है। स्थानीय स्तर भी समाज की संस्थायें सामाजिक गतिविधियों, समाज के भवनों व मंदिरों की व्यवस्था के कार्य बखूबी कर रही हैं। जैसे समाज के परिवार शहर के विभिन्न क्षेत्रों में निवास करते हैं, वैसे क्षेत्रवार समाज के भवनों का निर्माण कराया गया है, जो बहुत उपयोगी सिद्ध हो रहे हैं।

इस प्रकार बाड़मेर में विविधताओं से पूर्ण हमारा समाज अनेकता में एकता का संदेश दे रहा है। यहां के समाज बंधु व्यापार, उद्योग, हस्तशिल्प, पर्यटन, सरकारी सेवाओं आदि क्षेत्रों में अपनी प्रतिष्ठा बनाये हुये हैं।`,
    organizations: [
      'श्री ब्रह्मक्षत्रिय न्याति पंचायत, बाड़मेर',
      'श्री रायनगर ब्रह्मखत्री समिति, बाड़मेर',
      'श्री ब्रह्मक्षत्रिय (खत्री) समाज समिति, हिंगलाज नगर, बाड़मेर',
      'श्री हिंगलाज शक्तिपीठ संस्थान, बाड़मेर',
      'श्री ब्रह्मक्षत्रिय महिला मंडल',
      'श्री ब्रह्मक्षत्रिय नवयुवक मंडल',
      'श्री ब्रह्मक्षत्रिय मारवाड़ी युवा संस्थान (पंजीकृत) मुख्यालय बाड़मेर',
      'खत्री सामूहिक विवाह संस्थान, बाड़मेर - 2'
    ],
    buildings: [
      'खत्री समाज भवन, खत्रियों निचला वास, बाड़मेर',
      'श्री ब्रह्मक्षत्रिय पंचायत (न्याति) भवन, आजाद चौक, बाड़मेर',
      'लक्ष्मण भवन, बाड़मेर',
      'श्री ब्रह्मक्षत्रिय पंचायत (न्याति) भवन, नरगासर के पास, बाड़मेर',
      'राय नगर खत्री समाज भवन, राय कॉलोनी, बाड़मेर',
      'महावीर नगर में समाज भवन निर्माणाधीन',
      'हिंगलाज कॉलोनी में पार्टी प्लॉट',
      'विनायक चौक (ढाणी) में कूआ सह धर्मशाला',
      'डोला डूंगरी में समाज बंधु द्वारा भेंट किया हुआ मकान'
    ],
    temples: [
      'श्री हिंगलाज शक्तिपीठ, नरगासर के पास, बाड़मेर',
      'राज राजेश्वरी मां हिंगुलाज मन्दिर, हिंगलाज नगर, बाड़मेर',
      'श्री हिंगलाज मंदिर, हिंगलाज कॉलोनी, बाड़मेर'
    ],
    highlight: 'खत्री सामूहिक विवाह संस्थानों, बाड़मेर ने अभी तक छः सामूहिक विवाह समारोह आयोजित कर उल्लेखनीय कार्य किया है।'
  },
  {
    id: 'jaisalmer',
    name: 'जैसलमेर',
    nameEn: 'Jaisalmer',
    state: 'राजस्थान',
    families: '325',
    images: ['Jaisalmer_1.jpeg', 'Jaisalmer_2.jpeg', 'Jaisalmer_3.jpeg', 'Jaisalmer_4.jpeg', 'Jaisalmer_5.jpeg'],
    description: `राजस्थान के थार मरुस्थल के हृदय में स्थित जैसलमेर शहर महत्वपूर्ण व्यापार केंद्र रहा व अब प्रसिद्ध पर्यटन स्थल है।

जैसलमेर में हमारे समाज के 325 परिवार निवास करते हैं। यहां समाज का संगठन व परिवारों में समन्वय उल्लेखनीय है। हमारे समाज का प्रमुख मेला लोद्रवा, जैसलमेर में मां श्री हिंगलाज मंदिर प्रांगण में बहुत वर्षों से भरा जाता रहा है, जिसमें अनेक स्थानों के समाज बंधु शामिल होते रहे हैं। जैसलमेर समाज का आतिथ्य भाव विशिष्ट रहा है। अखिल भारतीय स्तर के समाज के संगठनों व कार्यों में यहां बंधुओं का योगदान रहा है।`,
    organizations: [
      'श्री ब्रह्मक्षत्रिय समाज समिति, जैसलमेर'
    ],
    buildings: [
      'न्याति नोहरा, श्री ब्रह्मक्षत्रिय खत्री समाज, खत्री पाड़ा, जैसलमेर',
      'श्री ब्रह्मक्षत्रिय समाज भवन व श्री हिंगलाज मंदिर, गांधी कॉलोनी, जैसलमेर',
      'निर्माणाधीन भवन, नव खुणिया, जैसलमेर',
      'मंदिर व भवन, जीवणयाई तलाई, जैसलमेर'
    ],
    temples: [
      'श्री हिंगलाज मंदिर, खत्रियों की तलाई, रतासर, जैसलमेर',
      'श्री हिंगलाज मंदिर, लोद्रवा, जैसलमेर'
    ],
    highlight: 'लोद्रवा, जैसलमेर में भाद्रपद माह में समाज का मेला वर्षों से भरा जाता रहा है।'
  },
  {
    id: 'deesa',
    name: 'डीसा',
    nameEn: 'Deesa',
    state: 'गुजरात',
    families: '280',
    images: ['Deesa_1.jpeg', 'Deesa_2.jpeg'],
    description: `गुजरात के डीसा में प्रगतिशील मारवाड़ी ब्रह्मक्षत्रिय समाज के 280 परिवार हैं। यहां गुजराती, मारवाड़ी व सिंधी भाषा व संस्कृति के संगम का दर्शन होता है। यहां के समाज बंधुओं का हमारे समाज के संगठनों के संचालन में काफी योगदान रहा है। स्थानीय स्तर पर भी संगठन का स्वरुप श्रेष्ठ है।`,
    organizations: [
      'श्री मारवाड़ी ब्रह्मक्षत्रिय समाज, सिंधी कॉलोनी, डीसा'
    ],
    temples: [
      'श्री हिंगलाज माता का भव्य मंदिर, डीसा'
    ],
    highlight: 'महिलाओं व युवाओं का योगदान उल्लेखनीय है। समाज का भव्य भवन निर्माणाधीन है।'
  },
  {
    id: 'balotra',
    name: 'बालोतरा',
    nameEn: 'Balotra',
    state: 'राजस्थान',
    families: '114',
    images: ['Balotra_1.jpeg', 'Balotra_2.jpeg', 'Balotra_3.jpeg'],
    description: `मालाणी क्षेत्र में बालोतरा अब जिला मुख्यालय है। बालोतरा के पास पचपदरा में रिफाइनरी का निर्माण हुआ है। निकट ही श्री राणी भटियानी मंदिर जसोल धाम आस्था का केंद्र है। प्रसिद्ध जैन तीर्थ नाकोड़ा भी यहीं है। यहां का कपड़ा उद्योग भारत भर में विख्यात है।

ऐसे महत्वपूर्ण क्षेत्र बालोतरा में हमारे समाज के 114 परिवार हैं। बालोतरा में नगरपालिका / नगर परिषद् में हमारे समाज के बंधुओं का वर्चस्व रहा है। समाज के बंधु सभी क्षेत्रों में प्रगतिशील हैं। समाज की अखिल भारतीय संस्थाओं में विशेष योगदान रहा है। 2025 में महासभा द्वारा आयोजित परिचय संगम में बालोतरा समाज का उल्लेखनीय सहयोग रहा। बालोतरा में सामूहिक विवाह का भव्य व सफल आयोजन किया गया।`,
    organizations: [
      'श्री खत्री समाज (पंचायत), बालोतरा',
      'श्री खत्री समाज शिक्षण एवम् सामूहिक विवाह संस्थान, बालोतरा',
      'श्री ब्रह्मक्षत्रिय महिला मंडल, बालोतरा',
      'श्री ब्रह्मक्षत्रिय युवक परिषद्, बालोतरा'
    ],
    buildings: [
      'श्री ब्रह्मक्षत्रिय पंचायत भवन, बालोतरा',
      'दयालीदेवी धणदे हिंगलाज भवन, बालोतरा',
      'श्री रामदेव मंदिर, श्री ब्रह्मक्षत्रिय समाज भवन, गौर का चौक, खत्री मार्केट, बालोतरा',
      'मेवानगर, बालोतरा में लगभग 15 बीघा भूमि, जिस पर रिसॉर्ट निर्माणाधीन है'
    ],
    temples: [
      'श्री मां हिंगलाज माताजी का मंदिर, बालोतरा'
    ],
    highlight: 'संस्थाओं व कार्यकर्ताओं की सक्रियता उल्लेखनीय है।',
  },
  {
    id: 'chennai',
    name: 'चैन्नई',
    nameEn: 'Chennai',
    state: 'तमिलनाडु',
    families: '135',
    images: ['Chennai_1.jpeg'],
    description: `पूर्व में मद्रास नाम से जाने वाले शहर का 1996 में नाम चैन्नई रखा गया। यह तमिलनाडु राज्य की राजधानी है।

वर्षों पूर्व मारवाड़ से हमारे समाज बंधुओं ने दक्षिण भारत की ओर रुख किया था। चैन्नई में आज हमारे परिवारों की संख्या 135 है। 1970 के दशक में गुजरात से आये ब्रह्मक्षत्रिय बंधुओं ने श्री मद्रास गुजराती समाज की स्थापना की। जब उन्हें मद्रास में मारवाड़ी ब्रह्मक्षत्रियों के भी होने की जानकारी हुयी तो उन्हे भी समाज को शामिल कर समाज को और संगठित किया। बाद में समाज का नाम बदल कर श्री मद्रास ब्रह्मक्षत्रिय समाज किया गया।

समाज के लिये भूखंड खरीदा गया। सन् 2000 तक भवन निर्माण करवाया गया व सन् 2001 में भवन व मंदिर की प्रतिष्ठा की गयी। मां हिंगलाज की प्रतिष्ठा की गयी। मां की कृपा से समाज बंधुओं व उनके व्यापार में प्रगति देखी गयी। आज सर्व सुविधा सम्पन्न तीन मंजिला भवन समाजोपयोगी सिद्ध हो रहा है।

23 जनवरी, 2026 को श्री हिंगलाज मंदिर का रजत जयंती पाटोत्सव सम्पन्न हुआ, जिसमें अनेक स्थानों के समाज बंधु शामिल हुये। व्यवस्था व मद्रास समाज का आतिथ्य भाव उल्लेखनीय रहा।`,
    organizations: [
      'श्री ब्रह्मक्षत्रिय समाज, चैन्नई',
      'श्री ब्रह्मक्षत्रिय महिला मंडल, चैन्नई',
      'श्री ब्रह्मक्षत्रिय युवक परिषद्, चैन्नई'
    ],
    buildings: [
      'खत्री मोहनलाल मुकनचंदजी छूंछा खत्री समाज भवन',
      'भवन में श्री हिंगलाज मंदिर'
    ],
    highlight: 'श्री हिंगलाज मंदिर का रजत जयंती पाटोत्सव सम्पन्न हुआ।'
  },
  {
    id: 'bengaluru',
    name: 'बेंगलुरू',
    nameEn: 'Bengaluru',
    state: 'कर्नाटक',
    families: '135',
    images: ['Bengaluru_1.jpeg'],
    description: `सिलीकोन वैली के नाम से विख्यात बेंगलुरू कर्नाटक राज्य की राजधानी है, जो आई टी हब के रुप में प्रसिद्ध है।

मारवाड़ से हमारे समाज बंधु व्यापार व रोजगार के उद्देश्य से वर्षों पूर्व बेंगलुरु जाने लगे। 1980 के दशक में वहां हमारे 15-20 परिवार थे, जो आज बढकर 135 हो गये हैं। वर्ष 1988-89 में ब्रह्मक्षत्रिय खत्री समाज का गठन किया गया। सभी परिवारों में आत्मीयता का व्यवहार रहा है।

समय के साथ परिवारों व दुकानों की संख्या बढती गयी। कुलदेवी हिंगलाज का मंदिर बनाने का विचार प्रस्तुत किया गया। शहर के बीचो बीच 1000 वर्ग फिट की भूमि समाज बंधु ने भेंट की। मंदिर ट्रस्ट बना व भव्य मंदिर बनकर तैयार हुआ। 27 जनवरी, 2023 को मंदिर में श्री हिंगलाज की प्राण प्रतिष्ठा की गयी। प्रतीष्ठा समारोह देश भर के समाज बंधुओं ने भाग लिया।

हाल ही में तीसरा पाटोत्सव समाज बंधुओं की उपस्थिति में सम्पन्न हुआ। मां हिंगलाज के आशीर्वाद से बेंगलुरु समाज सतत प्रगतिशील है। चार हजार वर्ग फिट नाप की जमीन भी ले रखी है, जिस पर बहु-उद्देश्यीय भव्य भवन निर्माण प्रस्तावित है।`,
    organizations: [
      'श्री ब्रह्मक्षत्रिय (खत्री) समाज ट्रस्ट मारवाड़ी, बेंगलुरू',
      'श्री ब्रह्मक्षत्रिय नवयुवक परिषद्, बेंगलुरू',
      'श्री ब्रह्मक्षत्रिय महिला मंडल, बेंगलुरू'
    ],
    highlight: '27 जनवरी, 2023 को मंदिर में श्री हिंगलाज की प्राण प्रतिष्ठा की गयी।'
  },
  {
    id: 'hyderabad',
    name: 'हैदराबाद',
    nameEn: 'Hyderabad',
    state: 'तेलंगाना',
    families: '150',
    description: `दक्षिण भारत के तेलंगाना राज्य की राजधानी हैदराबाद में हमारे समाज के 150 परिवार निवास करते हैं।`,
    organizations: [],
    highlight: '',
  },
  {
    id: 'surat',
    name: 'सूरत',
    nameEn: 'Surat',
    state: 'गुजरात',
    families: '188',
    description: `सूरत गुजरात का प्रमुख औद्योगिक शहर है, जो कपड़ा व्यापार व हीरे कटिंग व पॉलिशिंग के लिये विख्यात है।

मारवाड़ से हमारे समाज के बंधु व्यापार के उद्देश्य से आये व यहां बस गये। वर्तमान में यहां परिवारों की संख्या 188 है। समाज बंधु व्यापार में प्रगतिशील हैं। समाज का संगठन व समन्वय भी उल्लेखनीय है। यहां सामूहिक विवाह आयोजित हुये हैं।`,
    organizations: [
      'श्री दक्षिण गुजरात मारवाड़ी ब्रह्मक्षत्रिय समाज सूरत',
      'श्री दक्षिण गुजरात मारवाड़ी ब्रह्मक्षत्रिय नवयुवक मंडल, सूरत'
    ],
    highlight: 'यहां सामूहिक विवाह आयोजित हुये हैं।',
  },
  {
    id: 'daheli',
    name: 'डहेली विभाग',
    nameEn: 'Daheli Division',
    state: 'गुजरात',
    families: '150',
    images: ['Daheli_1.jpeg'],
    description: `गुजरात के भरुच जिले के गांव डहेली में मारवाड़ी ब्रह्मक्षत्रिय समाज के संगठन का एक विशिष्ट स्वरुप दिखाई देता है। डहेली में 25 परिवार निवास करते हैं लेकिन भरुच, सूरत व नर्मदा जिलों के लगभग 30 गांवों में लगभग 150 परिवार निवास करते हैं और डहेली इनका मुख्यालय है।

डहेली में समाज भवन व मंदिर स्थापित हैं। क्षेत्र का संगठन अद्वितीय है। यहां का समाज प्रगतिशील है। परिवारों में समन्वय उल्लेखनीय है। तीन पीढियों से वहां रह रहे परिवार भी आज भी मारवाड़ी भाषा बोलते हैं। यहां सामूहिक विवाह समारोह भी आयोजित हुये हैं।`,
    organizations: [
      'श्री ब्रह्मक्षत्रिय (मारवाड़ी) समाज, डहेली विभाग'
    ],
    highlight: 'तीन पीढियों से वहां रह रहे परिवार भी आज भी मारवाड़ी भाषा बोलते हैं।',
  },
  {
    id: 'ahmedabad',
    name: 'अहमदाबाद',
    nameEn: 'Ahmedabad',
    state: 'गुजरात',
    families: '145',
    description: `गुजरात के अहमदाबाद शहर में हमारे समाज के 145 परिवार निवास करते हैं। मारवाड़ से व्यापार व रोजगार के उद्देश्य से वहां गये व सफलता प्राप्त कर वहां बस गये है। अहमदाबाद में मां श्री हिंगलाज का मंदिर बनवाया गया है, जिसकी शीघ्र प्रतिष्ठा होने वाली है।`,
    organizations: [],
    temples: [
      'मां श्री हिंगलाज का मंदिर (शीघ्र प्रतिष्ठा होने वाली है)'
    ],
    highlight: 'मां श्री हिंगलाज का मंदिर बनवाया गया है।',
  },
  {
    id: 'sanchor',
    name: 'सांचोर',
    nameEn: 'Sanchor',
    state: 'राजस्थान',
    families: '180',
    description: `राजस्थान में गुजरात की सीमा के निकट जालोर जिले के सांचोर शहर में हमारे समाज बंधु प्रगतिशील हैं। शिक्षा प्रसार व रीति रिवाजों में सुधार जैसे प्रयास उल्लेखनीय हैं। स्थानीय स्तर व केंद्रीय स्तर पर सांचोर समाज का योगदान महत्वपूर्ण है।`,
    organizations: [
      'श्री ब्रह्मक्षत्रिय समाज सांचोर (108 परिवार)',
      'श्री ब्रह्मक्षत्रिय समाज समाज गोमी खैण सेवा समिति सांचोर (72 + 40 परिवार)'
    ],
    highlight: 'महिलाओं व युवाओं की सक्रियता उल्लेखनीय है।',
  },
  {
    id: 'chauhtan',
    name: 'चौहटन',
    nameEn: 'Chauhtan',
    state: 'राजस्थान',
    families: '52',
    description: `बाड़मेर जिले के चौहटन में हमारे परिवारों की संख्या 52 है। यहां समाज के दो भवन हैं। एक खत्रियों के वास में व दूसरा सुंदर नगर में। मंदिर पहाड़ी पर है।`,
    organizations: [
      'ब्रह्मक्षत्रिय खत्री समाज, चौहटन',
      'ब्रह्मक्षत्रिय शिक्षण संस्था, चौहटन'
    ],
    highlight: 'समाज प्रगतिशील है।',
  },
  {
    id: 'samdari',
    name: 'समदड़ी',
    nameEn: 'Samdari',
    state: 'राजस्थान',
    families: '77',
    images: ['Samdari_1.jpeg', 'Samdari_2.jpeg'],
    description: `बालोतरा जिले के समदड़ी में हमारे समाज के 37 परिवार स्थायी रुप से निवास करते हैं। लेकिन यहां के जो परिवार देशावर या अन्य स्थानों पर निवास करते हैं, उनको शामिल करें तो परिवारों की संख्या 77 है।`,
    organizations: [
      'ब्रह्मक्षत्रिय पंचायत संस्थान, समदड़ी'
    ],
    temples: [
      'श्री हिंगलाज मंदिर',
      'श्री रघुनाथजी - ठाकुरजी का मंदिर'
    ],
    highlight: 'समाज बंधु शिक्षा व व्यापार में प्रगतिशील हैं।',
  },
  {
    id: 'bikaner',
    name: 'बीकानेर',
    nameEn: 'Bikaner',
    state: 'राजस्थान',
    families: '110',
    images: ['Bikaner_1.jpeg', 'Bikaner_2.jpeg'],
    description: `बीकानेर में हमारे समाज के परिवारों की संख्या 110 है। यहां समाज बंधु शिक्षा व सरकारी सेवाओं में अग्रणी रहे हैं। तत्कालीन राजस्थान राज्य विद्युत मंडल में चीफ इंजीनियर पद पर आसीन हुये बीकानेर के हमारे बंधु ने विद्युत मंडल में काफी नियुक्तियां देकर एक उदाहरण प्रस्तुत किया था। आज भी हम उन्हें ससम्मान याद करते हैं।

बीकानेर समाज प्रगतिशील रहा है। समाज में संगठन व समन्वय उल्लेखनीय हैं। केंद्रीय संगठन में भी यहां के समाज बंधुओं का योगदान रहा है।`,
    organizations: [],
    buildings: [
      'समाज भवन, छब्बीली घाटी, बीकानेर',
      'प्लॉट 640 वर्ग फिट, छब्बीली घाटी, बीकानेर',
      '71 बिघा 4 बिस्वास जमीन लखी तलाई, पशु चिकित्सालय के पीछे, गोगा गेट, बीकानेर, जो सम्वत् 1882 में रु 1200 देकर समाज के नाम करायी थी। भूमि की सार संभाल नहीं होने के कारण बस्तियां बस गयी व प्रशासन ने कब्जा धारकों के पक्ष में पट्टे जारी कर दिये।',
      'समाज बंधु द्वारा प्रदत्त श्री कोलायतजी में 504 वर्ग गज का प्लॉट व जीर्ण-शीर्ण मंदिर'
    ],
    temples: [
      'श्री हिंगलाज देवी मंदिर व भूमि, लाल गुफा, बीकानेर'
    ],
    highlight: 'समाज बंधु शिक्षा व सरकारी सेवाओं में अग्रणी रहे हैं।',
  },
  {
    id: 'phalodi',
    name: 'फलोदी',
    nameEn: 'Phalodi',
    state: 'राजस्थान',
    families: '85',
    images: ['Pahlodi_1.jpeg'],
    description: `पश्चिम की काशी या छोटी काशी नाम से राजस्थान का लटियाल माता की कृपा पात्र शहर फलोदी अब एक जिला मुख्यालय है।

फलोदी में हमारे 85 परिवार निवास करते हैं, जो ज्यादातर व्यापार में संलग्न हैं। कुछ समाज बंधु रोजगार व व्यापार के उद्देश्य से अन्य शहरों में बसे।`,
    organizations: [
      'ब्रह्म खत्री समाज, फलोदी'
    ],
    buildings: [
      'श्री ब्रह्मक्षत्रिय समाज बगेची (नदी पार)',
      'एक पुराना कटला'
    ],
    highlight: 'पश्चिम की काशी या छोटी काशी नाम से राजस्थान का लटियाल माता की कृपा पात्र शहर।',
  },
  {
    id: 'setrawa',
    name: 'सेतरावा',
    nameEn: 'Setrawa',
    state: 'राजस्थान',
    families: '75',
    description: `सेतरावा अब फलोदी जिले में है। यहां हमारे समाज के 75 परिवार हैं। यहां श्री हिंगलाज मंदिर का निर्माण हो रहा है। समाज बंधु प्रगतिशील हैं।`,
    organizations: [
      'श्री ब्रह्मक्षत्रिय नवयुवक मंडल'
    ],
    temples: [
      'श्री हिंगलाज मंदिर (निर्माणाधीन)'
    ],
    highlight: 'श्री हिंगलाज मंदिर का निर्माण हो रहा है।',
  },
  {
    id: 'baap',
    name: 'बाप',
    nameEn: 'Baap',
    state: 'राजस्थान',
    families: '37',
    images: ['Bap_1.jpeg'],
    description: `फलोदी जिले के बाप कस्बे में हमारे 37 परिवार निवास करते हैं। समाज बंधु शिक्षा व व्यापार के क्षेत्र में प्रगतिशील हैं। यहां समाज का भवन है। परिवारों में संगठन व आत्मीयता की भावना उल्लेखनीय है।`,
    organizations: [],
    buildings: [
      'समाज भवन, बाप'
    ],
    highlight: 'परिवारों में संगठन व आत्मीयता की भावना उल्लेखनीय है।',
  },
  {
    id: 'tinwari',
    name: 'तिंवरी',
    nameEn: 'Tinwari',
    state: 'राजस्थान',
    families: '47',
    images: ['Tinwari_1.jpeg', 'Tinwari_2.jpeg', 'Tinwari_3.jpeg'],
    description: `जोधपुर के निकट तिंवरी में समाज के 47 परिवार निवास करते हैं।`,
    organizations: [
      'श्री खत्री (ब्रह्मक्षत्रिय) समाज विकास समिति तिंवरी'
    ],
    buildings: [
      'समाज भवन'
    ],
    temples: [
      'श्री हिंगलाज मंदिर व शक्तिपीठ'
    ],
    highlight: 'श्री हिंगलाज मंदिर व शक्तिपीठ प्रतिष्ठित हैं।',
  },
  {
    id: 'pokaran',
    name: 'पोकरण',
    nameEn: 'Pokaran',
    state: 'राजस्थान',
    families: '32',
    images: ['Pokran_1.jpeg', 'Pokran_2.jpeg'],
    description: `ऐतिहासिक शहर पोकरण "शक्ति स्थल" के रुप में विख्यात है। पोकरण में हमारे समाज के 32 परिवार हैं। यहां के समाज बंधु ने भारत भर से सूचनाएं एकत्र कर निर्देशकाओं का प्रकाशन किया। समाजोपयोगी वेब साइट का सृजन किया।

पोकरण फलसूंड रोड़ पर एक किलोमीटर दूर मेहरलाई तालाब पर कुलदेवी श्री हिंगलाज का पुरातन मंदिर है, जिसकी स्थापना खत्रियों के गुरु ने सन् 1877 में की थी। मंदिर की व्यवस्था खत्री समाज को सौंपी गयी, जिसे पोकरण समाज आज तक निभा रहा है। मंदिर परिसर में कमरे व बरामदा बना हुआ है। आने वाले यात्रियों के लिये सुविधाएं उपलब्ध हैं।

पोकरण के पास रामदेवरा में हमारे समाज के 11 परिवार निवास करते हैं। रामदेवरा में समाज की पुरानी धर्मशाला है। धर्मशाला भवन जीर्णोद्धार की प्रतीक्षा में है। इसके अतिरिक्त अब रामदेवरा में अखिल भारतीय ब्रह्मक्षत्रिय धर्मशाला ट्रस्ट रामदेवरा द्वारा नयी, आधुनिक व भव्य धर्मशाला का निर्माण करवाया गया है।`,
    organizations: [],
    buildings: [
      'समाज भवन, पोकरण',
      'मंदिर परिसर में कमरे व बरामदा',
      'रामदेवरा में पुरानी धर्मशाला',
      'अखिल भारतीय ब्रह्मक्षत्रिय धर्मशाला ट्रस्ट द्वारा नयी धर्मशाला, रामदेवरा'
    ],
    temples: [
      'कुलदेवी श्री हिंगलाज का पुरातन मंदिर, मेहरलाई तालाब (स्थापना 1877)'
    ],
    highlight: '"शक्ति स्थल" के रुप में विख्यात ऐतिहासिक शहर।',
  },
  {
    id: 'ramgarh',
    name: 'रामगढ',
    nameEn: 'Ramgarh',
    state: 'राजस्थान',
    families: '65',
    images: ['Ramgarh_1.jpeg'],
    description: `जैसलमेर से तन्नोट मार्ग पर ठेठ सीमांत क्षेत्र के गांव रामगढ में हमारे समाज के 65 परिवार हैं। यहां से निकले समाज बंधुओं ने अन्य स्थानों पर जाकर शिक्षा प्राप्त की व उच्च पदों पर पहुंचे। 1980 के दशक में यहां के हमारे शिक्षक बंधु को महामहिम राष्ट्रपति से राष्ट्रीय सम्मान प्राप्त हुआ था।

निकटस्थ तन्नोट में भी हिंगलाज मंदिर है, जिसका प्रबंध बी एस एफ द्वारा किया जाता है। 1965 व 1971 के युद्धों में पाकिस्तानी सेना द्वारा यहां सैकड़ों बम गिराये लेकिन एक भी बम नहीं फटा। इसे माता का चमत्कार का माना जाता है। रक्षा की देवी मानकर सेना के जवान मंदिर में आरती करते हैं व मंदिर के सभी प्रबंध करते हैं।

रामगढ में समाज का भवन है और भवन में ही श्री हिंगलाज मंदिर प्रतिष्ठित है। मां के आशीर्वाद से समाज प्रगति शील है।`,
    organizations: [],
    buildings: [
      'समाज भवन व श्री हिंगलाज मंदिर, रामगढ'
    ],
    temples: [
      'श्री हिंगलाज मंदिर, रामगढ',
      'हिंगलाज मंदिर, तन्नोट (BSF द्वारा प्रबंधित)'
    ],
    highlight: '1980 के दशक में यहां के हमारे शिक्षक बंधु को महामहिम राष्ट्रपति से राष्ट्रीय सम्मान प्राप्त हुआ था।',
  }
];

// Calculate stats
const totalFamilies = localSamajData.reduce((sum, item) => {
  const families = parseInt(item.families.replace('+', '')) || 0;
  return sum + families;
}, 0);
const totalLocations = localSamajData.length;
const totalStates = [...new Set(localSamajData.map(item => item.state))].length;

const LocalSamajDarshanPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [expandedCards, setExpandedCards] = useState({});

  // Get unique states for filter
  const states = [...new Set(localSamajData.map(item => item.state))].sort();

  // Filter data
  const filteredData = localSamajData.filter(item => {
    const matchesSearch = 
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.nameEn.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.state.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesState = selectedState ? item.state === selectedState : true;
    return matchesSearch && matchesState;
  });

  // Sort by families count (highest first)
  const sortedData = [...filteredData].sort((a, b) => {
    const aFamilies = parseInt(a.families.replace('+', '')) || 0;
    const bFamilies = parseInt(b.families.replace('+', '')) || 0;
    return bFamilies - aFamilies;
  });

  const toggleExpand = (id) => {
    setExpandedCards(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const clearFilters = () => {
    setSearchTerm('');
    setSelectedState('');
  };

  return (
    <div className="min-h-screen bg-white" data-testid="local-samaj-darshan-page">
      {/* Hero Section */}
      <section className="gradient-orange py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-2 text-white/80 text-sm mb-6">
            <a href="/" className="hover:text-white">Home</a>
            <span>›</span>
            <a href="/about" className="hover:text-white">About Samaj</a>
            <span>›</span>
            <span>Local Samaj Darshan</span>
          </div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              लोकल समाज दर्शन
            </h1>
            <p className="text-xl text-white/90 leading-relaxed">
              Local Samaj Darshan - विभिन्न स्थानों पर हमारे समाज की उपस्थिति, संस्थाएं एवं धरोहरें
            </p>
          </motion.div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Stats Cards */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12"
        >
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 text-center">
            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3">
              <Users className="w-6 h-6 text-primary" />
            </div>
            <h2 className="text-3xl font-bold text-primary mb-1">{totalFamilies.toLocaleString()}+</h2>
            <p className="text-gray-600 text-sm">कुल परिवार / Total Families</p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 text-center">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <MapPin className="w-6 h-6 text-blue-600" />
            </div>
            <h2 className="text-3xl font-bold text-blue-600 mb-1">{totalLocations}</h2>
            <p className="text-gray-600 text-sm">स्थान / Locations</p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 text-center">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <Building2 className="w-6 h-6 text-green-600" />
            </div>
            <h2 className="text-3xl font-bold text-green-600 mb-1">{totalStates}</h2>
            <p className="text-gray-600 text-sm">राज्य / States</p>
          </div>
        </motion.div>

        {/* Search and Filter */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 mb-8"
        >
          <div className="flex flex-col md:flex-row gap-4 items-start md:items-center">
            {/* Search Input */}
            <div className="relative flex-1 w-full">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Search by place name / स्थान खोजें..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all"
              />
            </div>

            {/* State Filter */}
            <div className="relative w-full md:w-64">
              <select
                value={selectedState}
                onChange={(e) => setSelectedState(e.target.value)}
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none appearance-none bg-white cursor-pointer"
              >
                <option value="">All States / सभी राज्य</option>
                {states.map(state => (
                  <option key={state} value={state}>{state}</option>
                ))}
              </select>
            </div>

            {/* Clear Filters */}
            {(searchTerm || selectedState) && (
              <button
                onClick={clearFilters}
                className="px-4 py-3 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-xl transition-all flex items-center gap-2"
              >
                <span>×</span>
                Clear
              </button>
            )}
          </div>

          {/* Results count */}
          {(searchTerm || selectedState) && (
            <div className="mt-4 pt-4 border-t border-gray-100">
              <span className="text-gray-600">
                Showing <span className="font-semibold text-primary">{sortedData.length}</span> of {localSamajData.length} locations
              </span>
            </div>
          )}
        </motion.div>

        {/* Location Cards */}
        <div className="space-y-6">
          {sortedData.map((location, index) => (
            <motion.div
              key={location.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden"
            >
              {/* Card Header */}
              <div 
                className="p-6 cursor-pointer bg-gray-50"
                onClick={() => toggleExpand(location.id)}
              >
                <div className="flex items-start justify-between">
                  <div className="flex items-start gap-4">
                    {/* Thumbnail or Icon */}
                    {location.images && location.images.length > 0 ? (
                      <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0 border border-gray-200">
                        <img
                          src={`${BACKEND_URL}/api/static/samaj-darshan/${location.images[0]}`}
                          alt={location.nameEn}
                          className="w-full h-full object-cover"
                          loading="lazy"
                        />
                      </div>
                    ) : (
                      <div className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0 bg-primary/10 text-primary">
                        <MapPin className="w-7 h-7" />
                      </div>
                    )}
                    <div>
                      <div className="flex items-center gap-3 mb-1">
                        <h2 className="text-2xl font-bold text-gray-900">{location.name}</h2>
                        <span className="text-lg text-gray-500">({location.nameEn})</span>
                      </div>
                      <div className="flex items-center gap-4 text-sm text-gray-600">
                        <span className="flex items-center gap-1">
                          <Building2 className="w-4 h-4" />
                          {location.state}
                        </span>
                        <span className="flex items-center gap-1">
                          <Users className="w-4 h-4" />
                          <strong className="text-primary">{location.families}</strong> परिवार
                        </span>
                        {location.images && location.images.length > 0 && (
                          <span className="flex items-center gap-1 text-blue-600">
                            <Image className="w-4 h-4" />
                            {location.images.length} photos
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
                    {expandedCards[location.id] ? (
                      <ChevronUp className="w-6 h-6 text-gray-500" />
                    ) : (
                      <ChevronDown className="w-6 h-6 text-gray-500" />
                    )}
                  </button>
                </div>

                {/* Highlight */}
                {location.highlight && (
                  <p className="mt-4 text-sm text-gray-700 italic border-l-4 border-primary pl-3 bg-white/50 py-2 rounded-r">
                    {location.highlight}
                  </p>
                )}
              </div>

              {/* Expanded Content */}
              {expandedCards[location.id] && (
                <div className="p-6 border-t border-gray-100">
                  {/* Image Gallery */}
                  {location.images && location.images.length > 0 && (
                    <div className="mb-6">
                      <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center gap-2">
                        <Image className="w-5 h-5 text-primary" />
                        फोटो गैलरी / Photo Gallery
                      </h3>
                      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
                        {location.images.map((img, idx) => (
                          <a 
                            key={idx}
                            href={`${BACKEND_URL}/api/static/samaj-darshan/${img}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block aspect-square rounded-lg overflow-hidden border border-gray-200 hover:border-primary hover:shadow-lg transition-all"
                          >
                            <img
                              src={`${BACKEND_URL}/api/static/samaj-darshan/${img}`}
                              alt={`${location.nameEn} ${idx + 1}`}
                              className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                              loading="lazy"
                            />
                          </a>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Description */}
                  <div className="prose prose-gray max-w-none mb-6">
                    {location.description.split('\n\n').map((para, idx) => (
                      <p key={idx} className="text-gray-700 leading-relaxed mb-4">
                        {para}
                      </p>
                    ))}
                  </div>

                  {/* Organizations */}
                  {location.organizations && location.organizations.length > 0 && (
                    <div className="mb-6">
                      <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center gap-2">
                        <Home className="w-5 h-5 text-primary" />
                        संस्थाएं / Organizations
                      </h3>
                      <div className="bg-orange-50 rounded-xl p-4">
                        <ul className="space-y-2">
                          {location.organizations.map((org, idx) => (
                            <li key={idx} className="flex items-start gap-2 text-gray-700">
                              <span className="text-primary mt-1">•</span>
                              <span>{org}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}

                  {/* Buildings */}
                  {location.buildings && location.buildings.length > 0 && (
                    <div className="mb-6">
                      <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center gap-2">
                        <Landmark className="w-5 h-5 text-blue-600" />
                        भवन / Buildings
                      </h3>
                      <div className="bg-blue-50 rounded-xl p-4">
                        <ul className="space-y-2">
                          {location.buildings.map((building, idx) => (
                            <li key={idx} className="flex items-start gap-2 text-gray-700">
                              <span className="text-blue-600 mt-1">•</span>
                              <span>{building}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}

                  {/* Temples */}
                  {location.temples && location.temples.length > 0 && (
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center gap-2">
                        <Church className="w-5 h-5 text-purple-600" />
                        मंदिर / Temples
                      </h3>
                      <div className="bg-purple-50 rounded-xl p-4">
                        <ul className="space-y-2">
                          {location.temples.map((temple, idx) => (
                            <li key={idx} className="flex items-start gap-2 text-gray-700">
                              <span className="text-purple-600 mt-1">•</span>
                              <span>{temple}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </motion.div>
          ))}
        </div>

        {/* No Results */}
        {sortedData.length === 0 && (
          <div className="text-center py-12 bg-gray-50 rounded-xl">
            <Search className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-gray-700 mb-2">कोई परिणाम नहीं मिला</h2>
            <p className="text-gray-500 mb-4">No results found for your search</p>
            <button
              onClick={clearFilters}
              className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
            >
              Clear Filters
            </button>
          </div>
        )}

        {/* Footer Note */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-12 bg-gradient-to-r from-primary/5 to-orange-50 rounded-2xl p-8 border border-primary/20"
        >
          <h3 className="text-lg font-semibold text-gray-900 mb-4">सूचना अपडेट करें / Update Information</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            यदि आपके क्षेत्र की जानकारी में कोई संशोधन या अतिरिक्त जानकारी है, तो कृपया हमसे संपर्क करें।
          </p>
          <a 
            href="mailto:brahmkhatrimahasabha@gmail.com" 
            className="inline-flex items-center gap-2 text-primary font-semibold hover:underline"
          >
            <span>brahmkhatrimahasabha@gmail.com</span>
          </a>
        </motion.div>
      </div>
    </div>
  );
};

export default LocalSamajDarshanPage;
